export default "__VITE_ASSET__C3QO5vwG__"